import styled from "styled-components";
import { fontSizes, lineHeights, rawColors as uiColors, spacing, typographyMixin } from "@magicbi/ui-library";
import { StackedMeter } from "../../atoms/StackedMeter";
import type { StackedMeterTone } from "../../atoms/StackedMeter/StackedMeter.types";

export const Root = styled.div`
  display: grid;
  gap: ${spacing[2]};
  min-width: 0;
`;

export const Bar = styled(StackedMeter)`
  width: 100%;
  margin-top: 0;

  /* The distribution red, not the theme's pink error. */
  > i[data-tone="error"] {
    background: ${uiColors.accent.red500};
  }
`;

export const Legend = styled.ul`
  display: flex;
  flex-wrap: wrap;
  gap: ${spacing[1]} ${spacing[4]};
  margin: 0;
  padding: 0;
  list-style: none;
  ${typographyMixin("body", 3)}
  font-size: ${fontSizes["13"]};
  line-height: ${lineHeights["18"]};
`;

export const Entry = styled.li<{ $tone: StackedMeterTone }>`
  color: ${({ $tone }) => ($tone === "error" ? uiColors.accent.red500 : uiColors.text.mediumEmphasis)};
`;
